import React from 'react';
import clsx from 'clsx';

import './index.scss';

const StepIcon = ({ step, doing })=>{

  return (
    <div className={clsx('StepIcon', { doing })}>
      {step}
    </div>
  );
};

export default StepIcon;